var React = require('react');

function DoubleQuoteInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1206_17285)","key":0},[React.createElement("path",{"d":"M20.5703 2.57129V17.9999H30.856C30.856 23.6713 26.2417 28.2856 20.5703 28.2856V33.4285C29.0781 33.4285 35.9989 26.5077 35.9989 17.9999V2.57129H20.5703Z","fill":"#001589","key":0}),React.createElement("path",{"d":"M0 17.9999H10.2857C10.2857 23.6713 5.67142 28.2856 0 28.2856V33.4285C8.50784 33.4285 15.4286 26.5077 15.4286 17.9999V2.57129H0V17.9999Z","fill":"#001589","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1206_17285"},React.createElement("rect",{"width":"36","height":"36","fill":"white"})))]);
}

DoubleQuoteInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = DoubleQuoteInline;

DoubleQuoteInline.default = DoubleQuoteInline;
